<template>
    <div class="table-layout mt10">
        <el-table :data="staffQualiList" border tooltip-effect="dark" style="width: 100%">
            <el-table-column prop="typeName" label="要求资质类型" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="levelName" label="要求资质等级(以上)" align="left" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="required" label="是否必需" align="center" width="100">
                <template slot-scope="rows">
                    <span v-if="rows.row.required">是</span>
                </template>
            </el-table-column>
            <el-table-column prop="engineerName" label="工程师" align="left" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metFlag" label="是否满足" align="center" width="100">
                <template slot-scope="rows">
                    <div v-if="rows.row.engineerId != -1">
                        <span v-if="rows.row.metFlag" class="font-green">是</span>
                        <span v-else-if="rows.row.required && !rows.row.metFlag" class="font-red">否</span>
                        <span v-else class="font-orange">否</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-servc-work-staff-quali-list',
        desc: '工单人员资质',
        props: {
            voucherId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                staffQualiList: [],
            }
        },
        created: function () {
            //
            this.getServcWorkStaffQualiListByVoucherId();
        },
        methods: {
            getServcWorkStaffQualiListByVoucherId: function () {
                let self = this;
                let postData = {};
                postData.voucherId = this.voucherId;
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkStaffQualiListByVoucherId(postData, function (result) {
                    theLoad.close();
                    if(result.type === "info") {
                        self.staffQualiList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkStaffQualiList.vue